import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Home, Privacy } from "@/marketing/Home";
import SharedGlossaryPage, { CreateSharePage } from "@/marketing/SharePages";
import PacksPage from "@/pages/PacksPage";
import ForNursesPage from "@/pages/ForNursesPage";
import AuthPage from "@/pages/AuthPage";
import AdminPage from "@/pages/AdminPage";

const AdminOnly = ({ children }) => {
  const { user } = useAuth();
  if (user === null) return <div className="grid min-h-screen place-items-center text-slate-500" data-testid="app-loading">Loading…</div>;
  if (!user || user.role !== "admin") return <Navigate to="/admin/login" replace />;
  return children;
};

function App() {
  useEffect(() => {
    document.title = "GlossLink — Highlight & Define Acronyms, Jargon & Hard Words on Any Website";
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/`).catch(() => {});
  }, []);
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/share" element={<CreateSharePage />} />
            <Route path="/g/:id" element={<SharedGlossaryPage />} />
            <Route path="/packs" element={<PacksPage />} />
            <Route path="/packs/:packId" element={<PacksPage />} />
            <Route path="/for-nurses" element={<ForNursesPage />} />
            <Route path="/admin/login" element={<AuthPage />} />
            <Route path="/admin" element={<AdminOnly><AdminPage /></AdminOnly>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
